/**
 *  AenaRoute script file
**/

import { mapGetters, mapActions } from 'vuex'
import { GETTERS, ACTIONS } from '@/store'
// import { PUBLIC_TRANSPORT } from '@/utils/routing-actions'
import setLocation from '@/mixins/setLocation'
import Searcher from '@/components/searcher/Searcher.vue'
import AenaPoints from '@/components/aena-points/AenaPoints.vue'
import getRoutePoint from '@/mixins/getRoutePoint'
import capitalize from '@/filters/capitalize'
import durationTime from '@/filters/durationTime'
import saveActions from '@/mixins/saveActions'
import displayCoordinates from '@/filters/displayCoordinates'
import { PUBLIC_TRANSPORT } from '@/utils/routing-actions'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaRoute',
  mixins: [getRoutePoint, setLocation, capitalize, durationTime, saveActions, displayCoordinates, setDeviceWidthClass],
  components: {
    Searcher,
    AenaPoints
  },
  props: {
    headerHeight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    // window.setTimeout(() => {
    //   if (this.$refs.route) {
    //     this.$refs.scrollContent.focus()
    //   }
    // }, 300)
    this.accessibilityEvents()
  },
  updated () {
    this.updateScrollbar()
    this.accessibilityEvents()
  },
  computed: {
    ...mapGetters({
      airportID: GETTERS.GET_AIRPORT_ID,
      floor: GETTERS.GET_FLOOR,
      building: GETTERS.GET_BUILDING,
      explorerMode: GETTERS.GET_EXPLORERMODE
    })
  },
  methods: {
    ...mapActions([
      ACTIONS.SET_COORDINATES
    ]),
    accessibilityEvents () {
      if (this.$refs.scrollContent) {
        // NOTE: accessibility trick
        this.$refs.scrollContent.addEventListener('mouseover', () => {
          this.$refs.scrollContent.style.visibility = 'visible'
        }, false)
        this.$refs.scrollContent.addEventListener('mouseout', () => {
          this.$refs.scrollContent.style.visibility = 'hidden'
        }, false)
      }
    },
    close () {
      this.$emit('onCloseRoute')
    },
    viewInMap (coordinates, building, floor) {
      this.saveFloor({ buildingId: building, floorId: floor, force: true, airportID: this.airportID, tag: 'explorador' })
      this[ACTIONS.SET_COORDINATES]({
        coordinates,
        zoom: 20
      })
    },
    selectGeometry (instruction, features, { oldStep, special }) {
      const poi = features[instruction.geometryindex]
      const type = instruction.tag.type.toUpperCase()

      let coordinates = poi.geometry.coordinates.slice(0, 2)
      let building = poi.properties.building

      if (PUBLIC_TRANSPORT.includes(type)) {
        building = (special ? oldStep : features[oldStep.geometryindex]).properties.building
      }

      const floor = poi.geometry.coordinates[poi.geometry.coordinates.length - 1] / this.routeC.z
      this.viewInMap(coordinates, building, floor)
    },
    getDistance (distance) {
      return this.$n(distance > 1 ? distance : 1, 'noDecimal')
    },
    getMsg (props) {
      const values = { ...props }

      if (values.direction) {
        values.direction = this.$t(values.direction)
      }

      if (values.duration) {
        values.duration = this.durationTime(values.duration)
      }
      if (values.destination) {
        values.destination = this.$t(values.destination)
      }

      if (values.transport) {
        values.transport = this.$t(values.transport)
      }

      if (values.oneWay) {
        values.oneWay = this.$t('ONEWAY_OPENING')
      }

      return values
    },
    getOldStep ({ instructions, index, rootIndex }) {
      if (!index) {
        if (!rootIndex) {
          return { oldStep: this.origin, special: true }
        } else {
          return { oldStep: this.newPoints[rootIndex - 1], special: true }
        }
      }
      return { oldStep: instructions[index - 1] }
    },
    getStepAriaLabel (step) {
      const isTag = step.type === 'tag'
      const action = (step.action === 'GO_UP' || step.action === 'GO_DOWN') ? this.$t('FLOOR') + step.currentFloor + '. ' : ''
      const type = (step.type !== 'tag') ? this.durationTime(step.time, { abbr: false }) + '. ' : ''
      return `${isTag ? '' : this.$t('IN_PREPOSITION')} ${
        this.$n(step.distance, 'noDecimal')} ${this.$t('METERS')
      }. ${
        this.$t(step.action, this.getMsg({ destination: step.direction, transport: step.transport }))
      }. ${action} ${type} ${this.$t(step.msg.label, this.getMsg(step.msg.props))}`
    },
    updateScrollbar () {
      window.setTimeout(() => {
        this.$refs.scrollbar.update()
      }, 100)
    }
  }
}
